import React from "react";
import { BrowserRouter as Router, Link } from "react-router-dom";
import {
  UserIcon,
  CircleStackIcon,
  ChartPieIcon,
  SquaresPlusIcon,
  VariableIcon,
  UserGroupIcon,
  UserCircleIcon,
  MapPinIcon,
} from "@heroicons/react/24/outline";

export default function CardsSimple() {
  return (
    <div className="section text-muted">
      <div className="container">
        <div className="row content justify-content-center">
          <div className="col-md-10 text-center">
            <div className="heading">
              <h1>Categorias</h1>
              <p className="lead">
                Tudo que você precisa saber para operar a plataforma Sales Box
                de acordo com a categoria
              </p>
            </div>
          </div>

          <div className="col-sm-12 col-md-6 col-lg-3 mb-3">
            <Link to="/integracoes" className="card-link">
              <div className="card card-minimal category-box text-center">
                <div className="card-body justify-content-center">
                  <a>
                    <SquaresPlusIcon className="icon-card-size" />
                  </a>

                  <h5 className="card-title">INTEGRAÇÕES</h5>

                  <small>Entenda como funciona</small>

                  <small>3 artigos</small>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-sm-6 col-md-4 col-lg-3 mb-3">
            <Link to="/data-analytics" className="card-link">
              <div className="card card-minimal category-box text-center">
                <div className="card-body justify-content-center">
                  <a>
                    <ChartPieIcon className="icon-card-size" />
                  </a>

                  <h5 className="card-title">DATA ANALYTICS</h5>

                  <small>Entenda como funciona</small>

                  <small>5 artigos</small>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-sm-6 col-md-4 col-lg-3 mb-3">
            <Link to="/data-intelligence" className="card-link">
              <div className="card card-minimal category-box text-center">
                <div className="card-body justify-content-center">
                  <a>
                    <CircleStackIcon className="icon-card-size" />
                  </a>

                  <h5 className="card-title">DATA INTELLIGENCE</h5>

                  <small>Entenda como funciona</small>

                  <small>3 artigos</small>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-sm-6 col-md-4 col-lg-3 mb-3">
            <Link to="/geomarketing" className="card-link">
              <div className="card card-minimal category-box text-center">
                <div className="card-body justify-content-center">
                  <a>
                    <MapPinIcon className="icon-card-size" />
                  </a>

                  <h5 className="card-title">GEOMARKETING</h5>

                  <small>Entenda como funciona</small>

                  <small>3 artigos</small>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-sm-6 col-md-4 col-lg-3 mb-3">
            <Link to="/personas-psicograficas" className="card-link">
              <div className="card card-minimal category-box text-center">
                <div className="card-body justify-content-center">
                  <a>
                    <UserCircleIcon className="icon-card-size" />
                  </a>

                  <h5 className="card-title">PERSONAS PSICOGRÁFICAS</h5>

                  <small>Entenda como funciona</small>

                  <small>1 artigo</small>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-sm-6 col-md-4 col-lg-3 mb-3">
            <Link to="/smart-segmentation" className="card-link">
              <div className="card card-minimal category-box text-center">
                <div className="card-body justify-content-center">
                  <a>
                    <UserGroupIcon className="icon-card-size" />
                  </a>

                  <h5 className="card-title">SMART SEGMENTATION</h5>

                  <small>Entenda como funciona</small>

                  <small>2 artigos</small>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-sm-12 col-md-6 col-lg-3 mb-3">
            <Link to="/variaveis-salesbox" className="card-link">
              <div className="card card-minimal category-box text-center">
                <div className="card-body justify-content-center">
                  <a>
                    <VariableIcon className="icon-card-size" />
                  </a>

                  <h5 className="card-title">VARIÁVEIS SALES BOX</h5>

                  <small>Entenda como funciona</small>

                  <small>3 artigos</small>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-sm-12 col-md-6 col-lg-3 mb-3">
            <Link to="/minha-conta-e-login" className="card-link">
              <div className="card card-minimal category-box text-center">
                <div className="card-body justify-content-center">
                  <a>
                    <UserIcon className="icon-card-size" />
                  </a>

                  <h5 className="card-title">MINHA CONTA E LOGIN</h5>

                  <small>Entenda como funciona</small>

                  <small>3 artigos</small>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
